import { supabaseClient } from "@/lib/supabase";
import type { BillingData } from "@/features/billing/api/useBilling";
import { queryOptions } from "@tanstack/react-query";

export const adminBillingByUserIdQueryKey = (userId: string) => ["admin", "billing", userId] as const;

export async function fetchBillingByUserId(userId: string): Promise<BillingData | null> {
    const { data, error } = await supabaseClient
        .from("billing")
        .select("*")
        .eq("user_id", userId)
        .order("created_at", { ascending: false })
        .limit(1)
        .maybeSingle();

    if (error) throw error;
    if (!data) return null;
    return data as BillingData;
}

export function selectBillingByUserIdQueryOptions(userId: string) {
    return queryOptions({
        queryKey: adminBillingByUserIdQueryKey(userId),
        queryFn: () => fetchBillingByUserId(userId),
    });
}
